type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'FiscalSetting'
const nameSource = 'financial/fiscalSettings'
const namePageTitle = 'Configurações'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Configurações',
  to: '/financial/fiscalSettings',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/financial/fiscalSettings/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/financial/fiscalSettings/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/financial/fiscalSettings/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
